import { FC } from 'react';
import { IntlProvider } from 'react-intl';
import enMessages from './messages/en.json';
// import arMessages from './messages/ar.json';
import { useLang } from './tazmeni18n';
import { WithChildren } from '../../app/helper/react18MigrationHelpers';
const allMessages = {
  // ar: arMessages,
  en: enMessages,
};

const I18nProvider: FC<WithChildren> = ({ children }) => {
  const locale = useLang();
  const messages = allMessages[locale];

  return (
    <IntlProvider locale={locale} messages={messages}>
      {children}
    </IntlProvider>
  );
};

export { I18nProvider };
